import { DirectDebitAutofillState } from '../reducers/direct.debit.autofill.reducer';
import { COMPLETE_ORDER_FEATURE } from '../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );

export const getDirectDebitAutofillState = createSelector(
  getCompleteOrderState,
  (state) => state?.directDebitAutofill
);

export const getDirectDebitReuse = createSelector(
  getDirectDebitAutofillState,
  (directDebitAutofillState: DirectDebitAutofillState) =>
    directDebitAutofillState?.data?.reuse_dd_details
);

export const getDirectDebitPaymentToken = createSelector(
  getDirectDebitAutofillState,
  (directDebitAutofillState: DirectDebitAutofillState) =>
    directDebitAutofillState?.data?.payment_token
);

export const getdirectDebitAutofillAvailable = createSelector(
  getDirectDebitAutofillState,
  (directDebitAutofillState: DirectDebitAutofillState) =>
    directDebitAutofillState?.data?.has_dd_details
);
